import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eebb1e12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cart-info" }
const _hoisted_2 = {
  key: 1,
  class: "cart-info__total"
}

import { RouteNames } from '@/router';
import { useCart, usePromo, usePagination } from '@/store';
import { storeToRefs } from 'pinia';
import { watch, ref, onUpdated } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartLink',
  setup(__props) {

const { cart } = storeToRefs(useCart());
const { totalPrice } = storeToRefs(usePromo());
const { page, limit } = storeToRefs(usePagination());

const iconAnimClass = ref('');
const countAnimClass = ref('');

watch(cart, (val, old) => {
    if (val.length > old.length) {
      iconAnimClass.value = 'play-cart-anim';
    }
    countAnimClass.value = 'cart-info__count_ping';
  }, { deep: true },
);

onUpdated(() => {
  if (iconAnimClass.value.length !== 0) {
    setTimeout(() => {
      iconAnimClass.value = '';
    }, 300);
  }

  if (countAnimClass.value.length !== 0) {
    setTimeout(() => {
      countAnimClass.value = '';
    }, 300);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RouterLink, {
      class: "a cart-info__link",
      to: { name: _unref(RouteNames).cart, query: { limit: `${_unref(limit)}`, page: `${_unref(page)}` } }
    }, {
      default: _withCtx(() => [
        _createElementVNode("i", {
          class: _normalizeClass([iconAnimClass.value, "icon-cart cart-info__icon"])
        }, null, 2 /* CLASS */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["to"]),
    (_unref(cart).length !== 0)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["cart-info__count", countAnimClass.value])
        }, _toDisplayString(_unref(cart).reduce((acc, val) => val.count + acc, 0)), 3 /* TEXT, CLASS */))
      : _createCommentVNode("v-if", true),
    (_unref(cart).length !== 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " $" + _toDisplayString(_unref(totalPrice).toFixed(2)), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})